module.exports = __webpack_public_path__ + "media/images/icons/placeholder_photo-0ad40c37bdd2f1cacaed079969fc0b41.png";